import * as React from 'react';
import { imgPath } from '../../../../common/utils/ImgUrl';
import { DetailsTooltipStyles } from '../DetailsTooltipStyles';
import { EntityLink, EntityLinkProps } from './EntityLink';

export interface RelatedEntityProps {
  label: string;
  link: EntityLinkProps;
  icon?: string;
}

export const RelatedEntity = (props: RelatedEntityProps) => {
  if (props.link) {
    return (
      <div className={DetailsTooltipStyles.MetadataSmallSection} style={{ display: 'flex', flexDirection: 'row' }}>
        <div style={{ flexGrow: 0 }}>{props.label}</div>
        {props.icon ? (
          <span style={{ position: 'relative', left: '16px', bottom: '2px', marginRight: '12px' }}>
            <img src={imgPath(props.icon)} alt={''} />
          </span>
        ) : (
          <></>
        )}
        <EntityLink styleOverride={{ marginLeft: '12px' }} {...props.link} />
      </div>
    );
  } else {
    return null;
  }
};
